import { v4 as uuidv4 } from 'uuid';
import MediaAndText from '../../components/composer/blocks/MediaAndText';
import TextBanner from '../../components/composer/blocks/TextBanner';
import Text from '../../components/composer/blocks/Text';
import HeroBanner from '../../components/composer/blocks/HeroBanner';
import ImageGrid from '../../components/composer/blocks/ImageGrid';
import { ComposerBlockElement, ComposerPageProps } from '../../types/composer';
import { parseLegacy } from './url';
import FeatureList from '../../components/composer/blocks/FeatureList';
import MediaAndTextList from '../../components/composer/blocks/MediaAndTextList';
import TabNavigation from '../../components/composer/blocks/TabNavigation';
import MediaCarousel from '../../components/composer/blocks/MediaCarousel';
import BookDownload from '../../components/composer/blocks/BookDownload';
import Quote from '../../components/composer/blocks/Quote';
import PlanSelector from '../../components/composer/blocks/PlanSelector';
import GuideGrid from '../../components/composer/blocks/GuideGrid';
import FeatureListNew from '../../components/composer/blocks/FeatureListNew';
import PlanSelectorNewComponent from '../../components/composer/blocks/PlanSelectorNew';
import MediaBanner from '../../components/composer/blocks/MediaBanner';
import MatrixColumns from '../../components/composer/blocks/MatrixColumns';
import VisitorTypeModal from '../../components/composer/blocks/VisitorTypeModal';
import DealBannerBlock from '../../components/composer/blocks/DealBanner';
import PodcastEpisodesList from '../../components/composer/blocks/PodcastEpisodesList';
import Answers from '../../components/composer/blocks/Answers';
import Resources from '../../components/composer/blocks/Resources';
import TestimonialCarousel from '../../components/composer/blocks/TestimonialCarousel';
import AppStoreLinks from '../../components/composer/blocks/AppStoreLinks';
import StatBlock from '../../components/composer/blocks/StatBlock';
import AnswersValueProp from '../../components/composer/blocks/AnswersValueProp';

export const PLACEHOLDER_NAME = 'placeholder-block';
const blocks = [
  HeroBanner,
  TextBanner,
  MediaAndText,
  FeatureList,
  ImageGrid,
  MediaAndTextList,
  MediaCarousel,
  BookDownload,
  Text,
  TabNavigation,
  Quote,
  PlanSelector,
  GuideGrid,
  FeatureListNew,
  PlanSelectorNewComponent,
  MediaBanner,
  MatrixColumns,
  PodcastEpisodesList,
  Answers,
  Resources,
  TestimonialCarousel,
  AppStoreLinks,
  StatBlock,
  AnswersValueProp,
] as ComposerBlockElement[];

export const legacyMap: Record<string, ComposerBlockElement> = {
  heroBanner: HeroBanner,
  textBanner: TextBanner,
  imageAndText: MediaAndText,
  featureList: FeatureList,
  imageGrid: ImageGrid,
  imageAndTextList: MediaAndTextList,
  mediaCarousel: MediaCarousel,
  bookDownload: BookDownload,
  text: Text,
  quoteBlock: Quote,
  planSelector: PlanSelector,
  GuideGrid: GuideGrid,
  featureListNew: FeatureListNew,
  planSelectorNew: PlanSelectorNewComponent as unknown as ComposerBlockElement,
  mediaBanner: MediaBanner as ComposerBlockElement,
  MatrixColumns: MatrixColumns,
  answersBlock: Answers as ComposerBlockElement,
  resources: Resources as ComposerBlockElement,
  appStoreLinks: AppStoreLinks,
};

/**
 * Blocks that are dynamically added to certain pages but are not editable
 * by the user.
 *
 * These blocks will still render via the BlockRenderer, however.
 */
const nonEditableBlocks = [VisitorTypeModal, DealBannerBlock];

/** Get a block by using the legacy name. */
export const getBlockByLegacyName = (
  composerName: string,
): ComposerBlockElement => {
  return legacyMap[composerName];
};

/** Gets a block. */
export const getBlock = (
  blockName: string,
): ComposerBlockElement | undefined => {
  return [...blocks, ...nonEditableBlocks].find(
    (b) => b.schema.name === blockName,
  );
};

/** Migrate blocks on a composer page. */
export const migrateBlocks = (page: ComposerPageProps): ComposerPageProps => {
  if (page.data.nextjs) {
    return page;
  }

  return {
    ...page,
    nodeID: null, // Remove current nodeID
    url: parseLegacy(page.route, page.url), // Make URL absolute
    data: {
      ...page.data,
      nextjs: true, // Flag for nextjs page
      content: {
        ...page.data.content,
        blocks: page.data.content.blocks.map((b) => ({
          ...b,
          name: getBlockByLegacyName(b.block || '')?.schema.name,
          id: uuidv4(),
        })),
      },
    },
  } as any; // FIXME: any
};

export default blocks;
